"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilExtractionConfig = void 0;
const zod_1 = require("zod");
const hilExtractionConfigSchema = zod_1.z.object({
    name: zod_1.z.string(),
    version: zod_1.z.number(),
    systemPrompt: zod_1.z.string().default(''),
    jsonSchemaString: zod_1.z.string().default(''),
    modelConfig: zod_1.z.object({
        model: zod_1.z.string().min(1, { message: 'Model is required' }),
        temperature: zod_1.z.number().optional(),
    }),
    examples: zod_1.z.array(zod_1.z.record(zod_1.z.string(), zod_1.z.string())).default([]),
});
exports.HilExtractionConfig = {
    create: (input) => {
        return hilExtractionConfigSchema.parse(input);
    },
    schema: hilExtractionConfigSchema,
};
//# sourceMappingURL=hil-extraction-config.js.map